import React from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 200px)',
        textAlign: 'center',
        gap: 3,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: '6rem',
          fontWeight: 'bold',
          color: '#f72bef',
          lineHeight: 1,
        }}
      >
        404
      </Typography>
      <Typography
        variant="h5"
        sx={{
          color: '#cacce5',
          fontWeight: 300,
        }}
      >
        This page does not exist.
      </Typography>
      <Button
        variant="contained"
        sx={{
          backgroundColor: '#f72bef',
          color: '#12131b',
          fontWeight: 'bold',
          px: 3,
          py: 1,
          '&:hover': {
            backgroundColor: '#c42ebe',
          },
        }}
        onClick={() => navigate('/main')}
      >
        Return to Main
      </Button>
    </Box>
  );
}
